import React from "react";
import { RiArrowLeftFill } from '@remixicon/react'
import { useNavigate } from "react-router-dom";

const BackButton = ({ href }) => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate(href);
  }

  return (
    <div className="flex gap-6 items-center w-full">
      <button
        className="flex justify-center items-center p-2.5 border border-gray-700 cursor-pointer h-[42px] rounded-[400px] w-[42px]"
        aria-label="Go back"
        onClick={() => {
          handleRedirect();
        }}
      >
        <RiArrowLeftFill color="rose" />
      </button>
    </div>
  );
};

export default BackButton;
